import comlogin from '@/components/ComLogin.vue';
import publicfooter from '@/components/footer.vue';
// eslint-disable-next-line no-unused-vars
import _ from 'lodash';
import que from '@/service/questions';
import mem from '@/service/member';
import store from '@/store';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    comlogin,
    Loading,
    publicfooter,
  },
  data() {
    return {
      filterExam: 0,
      isLoading: false,
      fullPage: true,
      buy: true,
      isSelected: false,
      selectedExamMethod: false,
      selectedMethodTmp: "",
      searchlist: [],
      // =============
      selecteddata: {
        year: "",
        method: "",
        lanuage: ""
      },
      examdata: {
        method: "",
        year: "",
        name: "",
        value: ""
      },
      // ===========
      selected: '',
      selected2: {
        type: '',
      },
      selected3: 0,
      test: '<h1>MYTEST</h1>',
      ExamSelected: 'exam_type2',
      radioData: [{
          text: '模擬考試',
          value: false,
        },
        {
          text: '隨答隨改',
          value: true,
        },
      ],
      options: [{
          item: 'CG',
          name: '華語導遊',
        },
        {
          item: 'EG',
          name: '外語導遊',
        },
        {
          item: 'CL',
          name: '華語領隊',
        },
        {
          item: 'EL',
          name: '外語領隊',
        },
      ],
    };
  },
  methods: {
    async searchexamlist() {

      if (this.isthrought) {
        const data = await this.$store.dispatch("indexPage/searchExamList", this.selecteddata);
        this.searchlist = data.exam;
        this.selectedMethodTmp = data.method;
      } else {
        // <span v-if='!selecteddata.year'>「年度」</span>
        //         <span v-if='!selecteddata.method'>「類科」</span>
        //         <span v-if='!selecteddata.lanuage'>「語種」</span>
        const h = this.$createElement;
        const showtext = ["您尚未選擇"];
        if (!this.selecteddata.year) {
          showtext.push("「年度」")
        }
        if (!this.selecteddata.method) {
          showtext.push("「考試類科」")
        }
        if (!this.selecteddata.lanuage) {
          showtext.push("「考試語種」")
        }
        const context = h("div", {
          class: "text-deepred"
        }, [showtext, '！']);
        this.$bvModal.msgBoxOk(context,
          {
            okTitle: '關閉',
            size: 'sm',
            buttonSize: 'md',
            okVariant: 'deepred',
            bodyClass: 'pt-4 border-bottom-0 text-center',
            footerClass: 'p-2 border-top-0',
            centered: true
          });
      }



    },
    // ==========================
    checkisLogin() {
      // const getRecordCon = mem.QuestionsRecord({ pk: this.userInfo_pk });
      // getRecordCon.then(response => response.data);
      this.selectedExamMethod = false;
      this.isLoading = true;
      const getRecordCon = store.dispatch('indexPage/getRecord', {
        pk: this.userInfo_pk,
      });
      getRecordCon.then((response) => {
        this.isLoading = false;

        const formatYear = _.padStart(this.selected3, 3, 0);

        if (!this.isLogin) {
          this.$bvModal.show('modal-login');
        } else if (
          this.selected === '' ||
          this.selected2 === {
            type: '',
          } ||
          this.selected3 === 0
        ) {
          // this.$bvModal.msgBoxOk('您尚未選擇考試題目 (包含類科、年度、科目)');
          this.isSelected = false;
        } else if (true) {
          this.isSelected = false;
          if (this.selected3 >= 102 && this.selected2.examId === 'UL3') {
            if (this.selected === 'CL') {
              this.selected2.examId = 'CL3';
            }
            if (this.selected === 'EL') {
              this.selected2.examId = 'EL3';
            }
          }
          if (this.selected3 === 107 &&
            (this.selected2.examId === 'CL2' ||
              this.selected2.examId === 'EL2' ||
              this.selected2.examId === 'EG2' ||
              this.selected2.examId === 'CG2')
          ) {
            this.selected2.examId = `U${this.selected2.examId.substring(1)}`;
          }
          if (this.selected3 === 108 &&
            (this.selected2.examId === 'CL2' ||
              this.selected2.examId === 'EL2' ||
              this.selected2.examId === 'EG2' ||
              this.selected2.examId === 'CG2')
          ) {
            this.selected2.examId = `U${this.selected2.examId.substring(1)}`;
          }
          if (this.selected3 === 109 &&
            (this.selected2.examId === 'CL2' ||
              this.selected2.examId === 'EL2' ||
              this.selected2.examId === 'EG2' ||
              this.selected2.examId === 'CG2')
          ) {
            this.selected2.examId = `U${this.selected2.examId.substring(1)}`;
          }
          if (this.selected !== '' &&
            this.selected2.type !== '' &&
            this.selected3 !== 0
          ) {

            const checkBuy = _.some(response.data, {
              exam_re: `EXAM_${formatYear}${this.selected2.examId}`,
            });
            this.buy = checkBuy;
            if (checkBuy) {
              this.selectedExamMethod = true;
            } else {
              this.isSelected = true;
            }
            this.$bvModal.show('modal-check_eaxm');
          } else {
            this.$bvModal.msgBoxOk('請選擇考題');
          }
        } else {
          this.isSelected = true;
        }

      });
    },
    async goexam(method, item, year) {
      const formatYear = _.padStart(year, 3, 0);
      if (method == "member") {
        if (!this.isLogin) {
          this.$bvModal.show('modal-login');
          this.loginsel = item;
          this.loginyear = year;
        } else {
          const response = await store.dispatch('indexPage/getRecord', {
            pk: this.userInfo_pk,
          }).then((data) => {
            return data.data;
          });

          //  getRecordCon.then((response) => {

          const checkBuy = _.some(response.result, {
            exam_re: `EXAM_${formatYear}${item.value}`,
          });
          this.buy = checkBuy;
          this.examdata = {
            year: formatYear,
            method: item.method,
            value: item.value,
            name: item.name,
            prename: item.prename
          }
          if (checkBuy) {
            this.selectedExamMethod = true;
          } else {
            this.isSelected = true;
          }
          this.$bvModal.show('modal-check_eaxm');
        }
      } else {
        this.$router.push({
          name: 'exam',
          params: {
            year: formatYear,
            type: item.method,
            examId: item.value,
            method: 'test',
          },
        });
      }

    },
    getQuestions() {
      if (this.selected3 >= 102 && this.selected2.examId === 'UL3') {
        if (this.selected === 'CL') {
          this.selected2.examId = 'CL3';
        }
        if (this.selected === 'EL') {
          this.selected2.examId = 'EL3';
        }
      }
      if (
        this.selected3 === 107 &&
        (this.selected2.examId === 'CL2' ||
          this.selected2.examId === 'EL2' ||
          this.selected2.examId === 'EG2' ||
          this.selected2.examId === 'CG2')
      ) {
        this.selected2.examId = `U${this.selected2.examId.substring(1)}`;
      }
      if (
        this.selected3 === 108 &&
        (this.selected2.examId === 'CL2' ||
          this.selected2.examId === 'EL2' ||
          this.selected2.examId === 'EG2' ||
          this.selected2.examId === 'CG2')
      ) {
        this.selected2.examId = `U${this.selected2.examId.substring(1)}`;
      }
      if (
        this.selected3 === 109 &&
        (this.selected2.examId === 'CL2' ||
          this.selected2.examId === 'EL2' ||
          this.selected2.examId === 'EG2' ||
          this.selected2.examId === 'CG2')
      ) {
        this.selected2.examId = `U${this.selected2.examId.substring(1)}`;
      }
      if (
        this.selected !== '' &&
        this.selected2.type !== '' &&
        this.selected3 !== 0
      ) {
        // this.$store.dispatch('exam/getQuestons', {
        //   year: this.selected3,
        //   type: this.selected2.type,
        //   examId: this.selected2.examId,
        //   method: 'test',
        // });
        this.$router.push({
          name: 'exam',
          params: {
            year: this.selected3,
            type: this.selected2.type,
            examId: this.selected2.examId,
            method: 'test',
          },
        });
      } else {
        // alert('請選擇考題');
        this.$bvModal.msgBoxOk('請選擇考題');
      }
    },
    async getQuestionsVip(close) {
      this.isLoading = true;
      const formatYear = _.padStart(this.examdata.year, 3, 0);
      if (this.buy) {
        this.$router.push({
          name: 'exam',
          params: {
            year: formatYear,
            type: this.examdata.method,
            examId: this.examdata.value,
            method: this.status,
          },
        });
      } else {
        const response = await que.buyquestions({
          exchname: `${this.examdata.year}年度${this.examdata.prename}${this.selectedMethodTmp}-${this.examdata.name}`,
          
          examId: `EXAM_${formatYear}${this.examdata.value}`,
        });
        // con.then((response) => {
        if (response.data.state) {

          this.$router.push({
            name: 'exam',
            params: {
              year: formatYear,
              type: this.examdata.method,
              examId: this.examdata.value,
              method: this.status,
            },
          });
        } else {
          this.$bvModal.msgBoxOk('您的點數已經用完，請來電至馬跡中心加值(02)2733-8118');
        }
        // });
      }
       this.isLoading = false;
      close();
      // } else {
      //   this.$bvModal.msgBoxOk('請選擇考題');
      // }
    },
    clean() {
      this.selected2 = {
        type: '',
      };
      this.selected3 = 0;
    },
    // clean2() {
    //   this.selected3 = 0;
    // },
    clean2() {
      this.selected2 = {
        type: '',
      };
    },
  },
  mounted() {
    this.$store.dispatch("indexPage/getIndexLayoutdata");
  },
  computed: {
    isthrought() {
      const throught = _.reduce(this.selecteddata, (cur, item) => {
        return cur && !!item;
      }, true);
      return throught;
    },
    getExamCount() {
      return _.reduce(this.searchlist, (cur, item) => {
        return cur + _.keys(item.data).length;
      }, 0)
    },
    getmehod() {
      return (this.selecteddata.method) ? (_.filter(this.getMethod, {
        "value": this.selecteddata.method
      })[0]) : {};
    },
    getyear: {
      get() {
        return this.$store.state.indexPage.publicValue.year;
      }
    },
    getMethod: {
      get() {
        return this.$store.state.indexPage.publicValue.method;
      }
    },
    getLanuage: {
      get() {

        return this.$store.state.indexPage.publicValue.lanuage;
      }
    },
    lastestID() {
      const year = this.options3.map(e => e.item);
      return _.max(year);
    },
    toZh: {
      get() {
        return this.$store.state.exam.toZh;
      },
    },
    single: {
      get() {
        return this.$store.state.exam.single;
      },
      set(value) {
        this.$store.commit('exam/checksingle', value);
      },
    },
    allwaysAns: {
      get() {
        return this.$store.state.exam.allwaysAns;
      },
      set(value) {
        this.$store.commit('exam/setAllwaysAns', value);
      },
    },
    userInfo_pk: {
      get() {
        return this.$store.state.indexPage.userinfo_pk;
      },
    },
    userInfo: {
      get() {
        return this.$store.state.indexPage.userinfo;
      },
    },
    isLogin: {
      get() {
        return this.$store.state.indexPage.isLogin;
      },
    },
    status: {
      get() {
        return this.$store.state.indexPage.status;
      },
    },
    options2() {
      const middle = this.selected.search(/G/i) > -1 ? 'G' : 'L';
      const b = [{
        item: {
          type: '',
        },
        name: '請選擇考試科目',
      }];
      if (this.selected3 !== 0) {
        b.push({
          item: {
            type: 'C',
            examId: `U${middle}1`,
          },
          name: '實務一',
        });
        b.push({
          item: {
            type: 'C',
            examId: `C${middle}2`,
          },
          name: '實務二',
        });
        b.push({
          item: {
            type: 'C',
            examId: `U${middle}3`,
          },
          name: '觀光資源概要',
        });

        // {
        //   item: 'CG',
        //   name: '華語導遊',
        // }, {
        //   item: 'EG',
        //   name: '外語導遊',
        // }, {
        //   item: 'CL',
        //   name: '華語領隊',
        // }, {
        //   item: 'EL',
        //   name: '外語領隊',
        // },
        // if (this.selected === 'EL' || this.selected === 'EG') {
        //   b.push({
        //     item: {
        //       type: 'E',
        //       examId: `E${middle}4`,
        //     },
        //     name: '英語',
        //   });
        //   b.push({
        //     item: {
        //       type: 'J',
        //       examId: `J${middle}5`,
        //     },
        //     name: '日語',
        //   });
        // }
      }
      if (
        (this.selected === 'EG' || this.selected === 'EL') &&
        this.selected3 < 96
      ) {
        b.pop();
      }
      return b;
    },
    options3() {
      const temp = [{
        item: 0,
        name: '請選擇年度',
      }];
      // this.selected2.type !== ''
      if (this.selected) {
        for (let i = 109; i >= 93; i -= 1) {
          temp.push({
            item: i,
            name: i,
          });
        }
      }
      // if (this.selected2.type === 'J') {
      //   for (let i = 0; i < 3; i += 1) {
      //     temp.pop();
      //   }
      // }
      return temp;
    },
    showYear() {
      let temp = 0;
      if (this.selected) {
        temp = 1;
      } else {
        temp = 0;
      }
      return temp;
    },
    showSubject() {
      let temp = 0;
      if (this.selected3 === 0) {
        temp = 0;
      } else {
        temp = 1;
      }
      return temp;
    },
  },
  watch: {
    isLogin(value) {
      if (value === true) {
        this.$bvModal.hide('modal-login');
        this.checkisLogin();
        if(this.loginsel){
          this.goexam('member', this.loginsel, this.loginyear)
        }
      }
      // this.test(value);
    },
  },
};
